module.exports = __webpack_public_path__ + "static/17-8a00feb94a20a397df36fed705e86650.jpg";